import React, { createContext, useContext, useEffect, useState } from "react";

const BRAND = "Jacinto's Culinary Atelier";

const STRINGS = {
  en: {
    brand: BRAND,
    nav_portfolio: "Portfolio",
    nav_bundles: "Passes",
    nav_capitals: "Capitals",
    nav_about: "Atelier",
    nav_dashboard: "My Recipes",
    nav_admin: "Admin",
    nav_login: "Sign in",
    nav_logout: "Sign out",
    hero_overline: "Private Chef · By Reservation Only",
    hero_title_a: "Marvellous dishes,",
    hero_title_b: "from the world’s capitals.",
    hero_sub: "Exclusive recipes by Chef Jacinto Samuel, composed for the most prestigious tables — from New York to Tokyo, Madrid to the Maldives. Each creation is yours, in writing, for life.",
    hero_cta: "Acquire a Recipe",
    hero_cta_2: "View Capitals",
    capitals_overline: "The Atlas",
    capitals_title: "Ten cities. One signature.",
    capitals_sub: "From mountain pass to harbour neon — the journey of a fork.",
    catalog_overline: "The Collection",
    catalog_title: "Recipes of the House",
    catalog_sub: "Each recipe is hand-typed by the Chef and delivered as a private, lifetime digital edition.",
    filter_all: "All",
    filter_meals: "Meals · £70",
    filter_desserts: "Desserts · £50",
    cta_buy: "Acquire — £",
    cta_unlock: "Unlock the Recipe",
    cta_owned: "In your collection",
    cta_view: "View",
    locked_note: "Ingredients & step-by-step method unlock after purchase.",
    about_overline: "The Atelier",
    about_title: "A culinary signature, written by hand.",
    about_p: "For over twenty years, Chef Jacinto Samuel has composed dishes for the world's most discreet dining rooms — from omakase counters in Tokyo to private cellars in Saint Petersburg. Each recipe is a one-off composition: a story of provenance, fire and silence.",
    footer_priv: "Private commissions",
    footer_follow: "Follow the atelier",
    footer_terms: "Terms",
    footer_privacy: "Privacy",
    footer_cookies: "Cookies",
    share_recipe: "Share this recipe",
    sign_in_with_google: "Continue with Google",
    sign_in_subtitle: "Sign in to acquire and access your private recipes.",
    success_title: "Your recipe is unlocked.",
    success_sub: "It now lives in your private collection.",
    success_cta: "Open recipe",
    pending: "Confirming payment…",
    fail_title: "Payment not confirmed",
    fail_sub: "If you were charged, please contact the atelier.",
    ingredients: "Ingredients",
    method: "Method",
    chef_note: "Chef’s note",
    by: "Composed for",
    in_: "in",
    page_dashboard_title: "Your private collection",
    page_dashboard_empty: "You have not yet acquired any recipes.",
    page_dashboard_browse: "Browse the collection",
    admin_title: "Atelier — Admin",
    admin_add: "New recipe",
    admin_ai_gen: "Generate with AI",
    admin_ai_img: "Generate dish image",
    admin_save: "Save recipe",
    admin_delete: "Delete",
    bundle_overline: "Tasting Passes",
    bundle_title: "Capital Pass & Grand Tour",
    bundle_sub: "Reserve an entire capital — or the whole atlas — at a single elegant price. Each pass quietly unlocks every recipe of its scope, for life.",
    bundle_grand_overline: "Grand Tour Atelier Pass",
    bundle_grand_title: "The whole world, in one pass.",
    bundle_grand_sub: "Every recipe, from every capital, present and future-added to your account upon release. The fullest expression of the Atelier.",
    bundle_grand_cta: "Acquire the Grand Tour",
    bundle_city_overline: "By Capital",
    bundle_city_title: "Capital Passes",
    bundle_recipes: "current recipes (more added by the Chef over time)",
    bundle_recipes_short: "recipes",
    bundle_lifetime: "Lifetime access · digital edition",
    bundle_bilingual: "Available in EN · PT · FR · ES",
    bundle_save: "Save",
    bundle_one_time: "One-time payment. No subscription. Stripe-secured.",
    bundle_capital_label: "Capital",
    bundle_more_soon: "More recipes coming to this capital",
    bundle_unlock_city: "Unlock all of",
    bundle_currency_note: "Lifetime access",
    bundle_legal: "All Capital Passes and the Grand Tour Pass are one-time digital acquisitions. Future recipes added by the Chef to a covered capital are automatically included at no extra cost. Stripe-secured. Refunds within 24h if no recipe has been opened.",
    hero_cta_3: "View Tasting Passes",
    bundle_grand_title_short: "Grand Tour",
    gift_this_pass: "Gift this pass",
    gift_modal_overline: "Gift a pass",
    gift_recipient_email: "Recipient's email",
    gift_recipient_name: "Recipient's name (optional)",
    gift_sender_name: "Your name (signed by)",
    gift_personal_message: "Personal message (optional)",
    gift_message_placeholder: "Wishing you a year as marvellous as this menu…",
    gift_modal_legal: "After payment, we'll send an elegant invitation to your recipient's email. They sign in with Google to claim it, and the recipes live in their account forever.",
    gift_pay: "Pay & send",
    gift_sent_overline: "Gift sent",
    gift_sent_title: "Your gift is on its way.",
    gift_sent_sub: "We've emailed an elegant invitation to your recipient. They can claim it whenever they like — it never expires.",
    gift_success_cta: "Back to atelier",
    gift_for_you: "A gift for you",
    hello: "Hello",
    gift_has_gifted_you: "has gifted you",
    gift_the: "the",
    gift_explainer: "This is a private, lifetime digital edition by Chef Jacinto Samuel — exclusive recipes composed for the world's most prestigious restaurants. Once you claim it, every recipe of its scope is yours, in writing, for life.",
    gift_value: "Gift value",
    gift_sign_in_to_claim: "Sign in with Google to claim your gift. Use any Google account.",
    gift_email_mismatch: "Note: this gift was originally addressed to a different email, but you can still claim it with your account.",
    gift_claim_cta: "Claim your gift",
    gift_claimed_success: "Gift claimed — it's now in your collection!",
    gift_already_claimed: "Already claimed",
    gift_lifetime_note: "One-time digital gift · No subscription · Valid forever",
  },
  es: {
    brand: "Atelier Culinario de Jacinto",
    nav_portfolio: "Portafolio",
    nav_bundles: "Pases",
    nav_capitals: "Capitales",
    nav_about: "Taller",
    nav_dashboard: "Mis Recetas",
    nav_admin: "Admin",
    nav_login: "Entrar",
    nav_logout: "Salir",
    hero_overline: "Chef Privado · Sólo por Reserva",
    hero_title_a: "Platos maravillosos,",
    hero_title_b: "desde las capitales del mundo.",
    hero_sub: "Recetas exclusivas del Chef Jacinto Samuel, compuestas para las mesas más prestigiosas — de Nueva York a Tokio, de Madrid a las Maldivas. Cada creación es tuya, por escrito, de por vida.",
    hero_cta: "Adquirir una Receta",
    hero_cta_2: "Ver Capitales",
    capitals_overline: "El Atlas",
    capitals_title: "Diez ciudades. Una firma.",
    capitals_sub: "Del paso de montaña al neón del puerto — el viaje de un tenedor.",
    catalog_overline: "La Colección",
    catalog_title: "Recetas de la Casa",
    catalog_sub: "Cada receta está escrita a mano por el Chef y entregada como edición digital privada de por vida.",
    filter_all: "Todas",
    filter_meals: "Platos · £70",
    filter_desserts: "Postres · £50",
    cta_buy: "Adquirir — £",
    cta_unlock: "Desbloquear la Receta",
    cta_owned: "En tu colección",
    cta_view: "Ver",
    locked_note: "Ingredientes y método paso a paso se desbloquean tras la compra.",
    about_overline: "El Taller",
    about_title: "Una firma culinaria, escrita a mano.",
    about_p: "Durante más de veinte años, el Chef Jacinto Samuel ha compuesto platos para los comedores más discretos del mundo — de barras de omakase en Tokio a bodegas privadas en San Petersburgo. Cada receta es una composición única: una historia de procedencia, fuego y silencio.",
    footer_priv: "Encargos privados",
    footer_follow: "Sigue el atelier",
    footer_terms: "Términos",
    footer_privacy: "Privacidad",
    footer_cookies: "Cookies",
    share_recipe: "Comparte esta receta",
    sign_in_with_google: "Continuar con Google",
    sign_in_subtitle: "Inicia sesión para adquirir y acceder a tus recetas privadas.",
    success_title: "Tu receta está desbloqueada.",
    success_sub: "Ahora vive en tu colección privada.",
    success_cta: "Abrir receta",
    pending: "Confirmando pago…",
    fail_title: "Pago no confirmado",
    fail_sub: "Si te cobraron, contacta al taller.",
    ingredients: "Ingredientes",
    method: "Método",
    chef_note: "Nota del chef",
    by: "Compuesto para",
    in_: "en",
    page_dashboard_title: "Tu colección privada",
    page_dashboard_empty: "Aún no has adquirido ninguna receta.",
    page_dashboard_browse: "Explorar la colección",
    admin_title: "Taller — Admin",
    admin_add: "Nueva receta",
    admin_ai_gen: "Generar con IA",
    admin_ai_img: "Generar imagen del plato",
    admin_save: "Guardar receta",
    admin_delete: "Eliminar",
    bundle_overline: "Pases Degustación",
    bundle_title: "Pase de Capital y Grand Tour",
    bundle_sub: "Reserva una capital entera — o todo el atlas — a un único precio elegante. Cada pase desbloquea silenciosamente todas las recetas de su alcance, de por vida.",
    bundle_grand_overline: "Pase Grand Tour del Atelier",
    bundle_grand_title: "El mundo entero, en un solo pase.",
    bundle_grand_sub: "Cada receta, de cada capital, presente y futura, se añade a tu cuenta al ser publicada. La máxima expresión del Atelier.",
    bundle_grand_cta: "Adquirir el Grand Tour",
    bundle_city_overline: "Por Capital",
    bundle_city_title: "Pases de Capital",
    bundle_recipes: "recetas actuales (el Chef añade más con el tiempo)",
    bundle_recipes_short: "recetas",
    bundle_lifetime: "Acceso de por vida · edición digital",
    bundle_bilingual: "Disponible en EN · PT · FR · ES",
    bundle_save: "Ahorra",
    bundle_one_time: "Pago único. Sin suscripción. Asegurado por Stripe.",
    bundle_capital_label: "Capital",
    bundle_more_soon: "Pronto más recetas en esta capital",
    bundle_unlock_city: "Desbloquear todo de",
    bundle_currency_note: "Acceso de por vida",
    bundle_legal: "Todos los Pases de Capital y el Grand Tour son adquisiciones digitales únicas. Las futuras recetas que el Chef añada a una capital incluida se suman automáticamente sin coste extra. Asegurado por Stripe. Reembolso en 24h si no se ha abierto ninguna receta.",
    hero_cta_3: "Ver Pases Degustación",
    bundle_grand_title_short: "Grand Tour",
    gift_this_pass: "Regalar este pase",
    gift_modal_overline: "Regalar un pase",
    gift_recipient_email: "Email del destinatario",
    gift_recipient_name: "Nombre del destinatario (opcional)",
    gift_sender_name: "Tu nombre (firma)",
    gift_personal_message: "Mensaje personal (opcional)",
    gift_message_placeholder: "Te deseo un año tan maravilloso como este menú…",
    gift_modal_legal: "Tras el pago, enviaremos una invitación elegante al email del destinatario. Inicia sesión con Google para reclamarlo y las recetas viven en su cuenta para siempre.",
    gift_pay: "Pagar y enviar",
    gift_sent_overline: "Regalo enviado",
    gift_sent_title: "Tu regalo está en camino.",
    gift_sent_sub: "Hemos enviado una invitación elegante al email del destinatario. Puede reclamarlo cuando quiera — no caduca nunca.",
    gift_success_cta: "Volver al atelier",
    gift_for_you: "Un regalo para ti",
    hello: "Hola",
    gift_has_gifted_you: "te ha regalado",
    gift_the: "el",
    gift_explainer: "Es una edición digital privada y vitalicia del Chef Jacinto Samuel — recetas exclusivas compuestas para los restaurantes más prestigiosos del mundo. Al reclamarla, cada receta de su alcance es tuya, por escrito, de por vida.",
    gift_value: "Valor del regalo",
    gift_sign_in_to_claim: "Inicia sesión con Google para reclamar tu regalo. Puedes usar cualquier cuenta de Google.",
    gift_email_mismatch: "Nota: este regalo fue dirigido a otro email, pero puedes reclamarlo con tu cuenta.",
    gift_claim_cta: "Reclamar mi regalo",
    gift_claimed_success: "¡Regalo reclamado — ya está en tu colección!",
    gift_already_claimed: "Ya reclamado",
    gift_lifetime_note: "Regalo digital de pago único · Sin suscripción · Válido para siempre",
  },
  pt: {
    brand: "Atelier Culinário do Jacinto",
    nav_portfolio: "Portefólio",
    nav_bundles: "Passes",
    nav_capitals: "Capitais",
    nav_about: "Atelier",
    nav_dashboard: "As Minhas Receitas",
    nav_admin: "Admin",
    nav_login: "Entrar",
    nav_logout: "Sair",
    hero_overline: "Chef Privado · Apenas por Reserva",
    hero_title_a: "Pratos maravilhosos,",
    hero_title_b: "das capitais do mundo.",
    hero_sub: "Receitas exclusivas do Chef Jacinto Samuel, compostas para as mesas mais prestigiadas — de Nova Iorque a Tóquio, de Madrid às Maldivas. Cada criação é sua, por escrito, para toda a vida.",
    hero_cta: "Adquirir uma Receita",
    hero_cta_2: "Ver Capitais",
    capitals_overline: "O Atlas",
    capitals_title: "Dez cidades. Uma assinatura.",
    capitals_sub: "Do passo de montanha ao néon do porto — a viagem de um garfo.",
    catalog_overline: "A Colecção",
    catalog_title: "Receitas da Casa",
    catalog_sub: "Cada receita é escrita à mão pelo Chef e entregue como edição digital privada vitalícia.",
    filter_all: "Todas",
    filter_meals: "Pratos · £70",
    filter_desserts: "Sobremesas · £50",
    cta_buy: "Adquirir — £",
    cta_unlock: "Desbloquear a Receita",
    cta_owned: "Na sua colecção",
    cta_view: "Ver",
    locked_note: "Ingredientes e método passo a passo desbloqueiam após a compra.",
    about_overline: "O Atelier",
    about_title: "Uma assinatura culinária, escrita à mão.",
    about_p: "Há mais de vinte anos, o Chef Jacinto Samuel compõe pratos para as salas mais discretas do mundo — dos balcões de omakase em Tóquio às adegas privadas em São Petersburgo. Cada receita é uma composição única: uma história de proveniência, fogo e silêncio.",
    footer_priv: "Encomendas privadas",
    footer_follow: "Siga o atelier",
    footer_terms: "Termos",
    footer_privacy: "Privacidade",
    footer_cookies: "Cookies",
    share_recipe: "Partilhe esta receita",
    sign_in_with_google: "Continuar com Google",
    sign_in_subtitle: "Inicie sessão para adquirir e aceder às suas receitas privadas.",
    success_title: "A sua receita está desbloqueada.",
    success_sub: "Agora vive na sua colecção privada.",
    success_cta: "Abrir receita",
    pending: "A confirmar pagamento…",
    fail_title: "Pagamento não confirmado",
    fail_sub: "Se foi cobrado, contacte o atelier.",
    ingredients: "Ingredientes",
    method: "Método",
    chef_note: "Nota do chef",
    by: "Composta para",
    in_: "em",
    page_dashboard_title: "A sua colecção privada",
    page_dashboard_empty: "Ainda não adquiriu nenhuma receita.",
    page_dashboard_browse: "Explorar a colecção",
    admin_title: "Atelier — Admin",
    admin_add: "Nova receita",
    admin_ai_gen: "Gerar com IA",
    admin_ai_img: "Gerar imagem do prato",
    admin_save: "Guardar receita",
    admin_delete: "Eliminar",
    bundle_overline: "Passes de Degustação",
    bundle_title: "Passe de Capital e Grand Tour",
    bundle_sub: "Reserve uma capital inteira — ou todo o atlas — por um único preço elegante. Cada passe desbloqueia silenciosamente todas as receitas do seu âmbito, para a vida.",
    bundle_grand_overline: "Passe Grand Tour do Atelier",
    bundle_grand_title: "O mundo inteiro, num só passe.",
    bundle_grand_sub: "Cada receita, de cada capital, presente e futura, é adicionada à sua conta no momento do lançamento. A expressão mais completa do Atelier.",
    bundle_grand_cta: "Adquirir o Grand Tour",
    bundle_city_overline: "Por Capital",
    bundle_city_title: "Passes de Capital",
    bundle_recipes: "receitas actuais (o Chef adiciona mais ao longo do tempo)",
    bundle_recipes_short: "receitas",
    bundle_lifetime: "Acesso vitalício · edição digital",
    bundle_bilingual: "Disponível em EN · PT · FR · ES",
    bundle_save: "Poupa",
    bundle_one_time: "Pagamento único. Sem subscrição. Protegido pelo Stripe.",
    bundle_capital_label: "Capital",
    bundle_more_soon: "Em breve mais receitas nesta capital",
    bundle_unlock_city: "Desbloquear toda",
    bundle_currency_note: "Acesso vitalício",
    bundle_legal: "Todos os Passes de Capital e o Grand Tour são aquisições digitais únicas. Receitas futuras adicionadas pelo Chef a uma capital coberta são incluídas automaticamente sem custo adicional. Protegido pelo Stripe. Reembolso em 24h caso nenhuma receita tenha sido aberta.",
    hero_cta_3: "Ver Passes de Degustação",
    bundle_grand_title_short: "Grand Tour",
    gift_this_pass: "Oferecer este passe",
    gift_modal_overline: "Oferecer um passe",
    gift_recipient_email: "Email do destinatário",
    gift_recipient_name: "Nome do destinatário (opcional)",
    gift_sender_name: "Teu nome (assinado por)",
    gift_personal_message: "Mensagem pessoal (opcional)",
    gift_message_placeholder: "Desejo-te um ano tão maravilhoso como este menu…",
    gift_modal_legal: "Após o pagamento, enviamos um convite elegante ao email do destinatário. Inicia sessão com Google para reclamar e as receitas ficam na sua conta para sempre.",
    gift_pay: "Pagar e enviar",
    gift_sent_overline: "Oferta enviada",
    gift_sent_title: "A tua oferta está a caminho.",
    gift_sent_sub: "Enviámos um convite elegante ao email do destinatário. Pode reclamar quando quiser — não expira.",
    gift_success_cta: "Voltar ao atelier",
    gift_for_you: "Uma oferta para ti",
    hello: "Olá",
    gift_has_gifted_you: "ofereceu-te",
    gift_the: "o",
    gift_explainer: "É uma edição digital privada e vitalícia do Chef Jacinto Samuel — receitas exclusivas compostas para os restaurantes mais prestigiados do mundo. Ao reclamar, cada receita do seu âmbito é tua, por escrito, para a vida.",
    gift_value: "Valor da oferta",
    gift_sign_in_to_claim: "Inicia sessão com Google para reclamar a tua oferta. Qualquer conta Google serve.",
    gift_email_mismatch: "Nota: esta oferta foi enviada para outro email, mas podes reclamá-la com a tua conta.",
    gift_claim_cta: "Reclamar a oferta",
    gift_claimed_success: "Oferta reclamada — já está na tua colecção!",
    gift_already_claimed: "Já reclamada",
    gift_lifetime_note: "Oferta digital de pagamento único · Sem subscrição · Válido para sempre",
  },
  fr: {
    brand: "Atelier Culinaire de Jacinto",
    nav_portfolio: "Portfolio",
    nav_bundles: "Pass",
    nav_capitals: "Capitales",
    nav_about: "Atelier",
    nav_dashboard: "Mes Recettes",
    nav_admin: "Admin",
    nav_login: "Se connecter",
    nav_logout: "Déconnexion",
    hero_overline: "Chef Privé · Uniquement sur Réservation",
    hero_title_a: "Plats merveilleux,",
    hero_title_b: "depuis les capitales du monde.",
    hero_sub: "Recettes exclusives du Chef Jacinto Samuel, composées pour les tables les plus prestigieuses — de New York à Tokyo, de Madrid aux Maldives. Chaque création est vôtre, par écrit, à vie.",
    hero_cta: "Acquérir une Recette",
    hero_cta_2: "Voir les Capitales",
    capitals_overline: "L'Atlas",
    capitals_title: "Dix villes. Une signature.",
    capitals_sub: "Du col de montagne au néon du port — le voyage d'une fourchette.",
    catalog_overline: "La Collection",
    catalog_title: "Recettes de la Maison",
    catalog_sub: "Chaque recette est écrite à la main par le Chef et livrée en édition numérique privée à vie.",
    filter_all: "Toutes",
    filter_meals: "Plats · £70",
    filter_desserts: "Desserts · £50",
    cta_buy: "Acquérir — £",
    cta_unlock: "Déverrouiller la Recette",
    cta_owned: "Dans votre collection",
    cta_view: "Voir",
    locked_note: "Ingrédients et méthode pas-à-pas se déverrouillent après achat.",
    about_overline: "L'Atelier",
    about_title: "Une signature culinaire, écrite à la main.",
    about_p: "Depuis plus de vingt ans, le Chef Jacinto Samuel compose des plats pour les salles les plus discrètes du monde — des comptoirs omakase de Tokyo aux caves privées de Saint-Pétersbourg. Chaque recette est une composition unique : une histoire de provenance, de feu et de silence.",
    footer_priv: "Commandes privées",
    footer_follow: "Suivez l'atelier",
    footer_terms: "Conditions",
    footer_privacy: "Confidentialité",
    footer_cookies: "Cookies",
    share_recipe: "Partagez cette recette",
    sign_in_with_google: "Continuer avec Google",
    sign_in_subtitle: "Connectez-vous pour acquérir et accéder à vos recettes privées.",
    success_title: "Votre recette est déverrouillée.",
    success_sub: "Elle vit désormais dans votre collection privée.",
    success_cta: "Ouvrir la recette",
    pending: "Confirmation du paiement…",
    fail_title: "Paiement non confirmé",
    fail_sub: "Si vous avez été débité, contactez l'atelier.",
    ingredients: "Ingrédients",
    method: "Méthode",
    chef_note: "Note du chef",
    by: "Composée pour",
    in_: "à",
    page_dashboard_title: "Votre collection privée",
    page_dashboard_empty: "Vous n'avez encore acquis aucune recette.",
    page_dashboard_browse: "Parcourir la collection",
    admin_title: "Atelier — Admin",
    admin_add: "Nouvelle recette",
    admin_ai_gen: "Générer avec l'IA",
    admin_ai_img: "Générer image du plat",
    admin_save: "Enregistrer la recette",
    admin_delete: "Supprimer",
    bundle_overline: "Pass Dégustation",
    bundle_title: "Pass Capitale & Grand Tour",
    bundle_sub: "Réservez une capitale entière — ou tout l'atlas — à un seul prix élégant. Chaque pass déverrouille silencieusement toutes les recettes de son périmètre, à vie.",
    bundle_grand_overline: "Pass Grand Tour de l'Atelier",
    bundle_grand_title: "Le monde entier, en un seul pass.",
    bundle_grand_sub: "Chaque recette, de chaque capitale, présente et future, ajoutée à votre compte dès sa sortie. L'expression la plus complète de l'Atelier.",
    bundle_grand_cta: "Acquérir le Grand Tour",
    bundle_city_overline: "Par Capitale",
    bundle_city_title: "Pass Capitale",
    bundle_recipes: "recettes actuelles (le Chef en ajoute au fil du temps)",
    bundle_recipes_short: "recettes",
    bundle_lifetime: "Accès à vie · édition numérique",
    bundle_bilingual: "Disponible en EN · PT · FR · ES",
    bundle_save: "Économisez",
    bundle_one_time: "Paiement unique. Sans abonnement. Sécurisé par Stripe.",
    bundle_capital_label: "Capitale",
    bundle_more_soon: "Bientôt plus de recettes dans cette capitale",
    bundle_unlock_city: "Tout déverrouiller à",
    bundle_currency_note: "Accès à vie",
    bundle_legal: "Tous les Pass Capitale et le Grand Tour sont des acquisitions numériques uniques. Les futures recettes ajoutées par le Chef à une capitale couverte sont automatiquement incluses sans frais. Sécurisé par Stripe. Remboursement sous 24h si aucune recette n'a été ouverte.",
    hero_cta_3: "Voir les Pass Dégustation",
  },
};

const SUPPORTED = ["en", "pt", "fr", "es"];
const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {}, supported: SUPPORTED });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("lang");
    return SUPPORTED.includes(saved) ? saved : "en";
  });
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (k) => STRINGS[lang]?.[k] ?? STRINGS.en[k] ?? k;
  return <I18nCtx.Provider value={{ lang, setLang, t, supported: SUPPORTED }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
